import coachSlice from "./coachSlice";
import studentSlice from "./studentSlice";
import feedbackSlice from "./feedbackSlice";
import adminUserSlice from "./adminUserSlice";
import messageSlice from "./messageSlice";

export const allAdminSlices = {
  coach: coachSlice,
  student: studentSlice,
  feedback: feedbackSlice,
  adminUser: adminUserSlice,
  messages: messageSlice,
};
